import React, { useEffect, useState } from 'react'
import SocialMedia from '../../component/SocialMedia/socialMedia'
import { FaEnvelope } from 'react-icons/fa' 

function Contact() {
  const [scrollY, setScrollY] = useState(0)

  useEffect(() => {
    const handleScroll = () => setScrollY(window.scrollY)
    window.addEventListener('scroll', handleScroll)
    return () => window.removeEventListener('scroll', handleScroll)
  }, [])

  return (
    <div style={{ fontFamily: "'Roboto', sans-serif", margin: 0, padding: 0 }}>
      {/* Hero */}
      <section style={{ height: '48vh', minHeight: 360, display: 'flex', alignItems: 'center', justifyContent: 'center', textAlign: 'center', background: 'linear-gradient(135deg, #667eea, #764ba2)', color: '#fff', padding: '0 20px', opacity: scrollY < 80 ? 1 : 0.95, transition: 'opacity 0.6s ease' }}>
        <div>
          <FaEnvelope style={{ fontSize: 48, marginBottom: 10 }} />
          <h1 style={{ fontSize: '40px', fontWeight: 700, margin: '6px 0 12px', transform: `translateY(${scrollY * 0.05}px)`, transition: 'transform 0.3s ease-out' }}>Contact</h1>
          <p style={{ fontSize: '18px', maxWidth: 820, margin: '0 auto', lineHeight: 1.6 }}>I'd love to hear about your project or opportunity — reach out and let's chat.</p>
        </div>
      </section>

      <main style={{ maxWidth: '900px', margin: '0 auto', padding: '80px 20px 60px 20px' }}>
        <section style={{ marginBottom: '40px', opacity: scrollY > 50 ? 1 : 0, transform: scrollY > 50 ? 'translateY(0)' : 'translateY(20px)', transition: 'all 0.7s ease-out' }}>
          <h2 style={{ fontSize: '28px', borderBottom: '3px solid #667eea', display: 'inline-block', paddingBottom: '6px', color: '#333', marginBottom: '14px' }}>Get in touch</h2>
          <p style={{ color: '#555' }}>Prefer email? <a href="mailto:example@email.com" style={{ color: '#667eea', textDecoration: 'none' }}>example@email.com</a></p>

          <SocialMedia links={[{ label: 'GitHub', url: 'https://github.com/' }, { label: 'LinkedIn', url: 'https://linkedin.com/' }]} size={44} />
        </section>

        <section style={{ marginTop: 30, textAlign: 'center' }}>
          <h2 style={{ fontSize: '26px', borderBottom: '3px solid #667eea', display: 'inline-block', paddingBottom: '6px', color: '#333', marginBottom: '18px' }}>Send a message</h2>
          <form onSubmit={(e) => e.preventDefault()} style={{ display: 'grid', gap: 12, maxWidth: 680, margin: '16px auto 0' }}>
            <input placeholder="Your name" style={{ padding: '12px 14px', borderRadius: 8, border: '1px solid #e6e8ff', fontSize: 16 }} />
            <input placeholder="Email" style={{ padding: '12px 14px', borderRadius: 8, border: '1px solid #e6e8ff', fontSize: 16 }} />
            <textarea placeholder="Message" rows={6} style={{ padding: '12px 14px', borderRadius: 8, border: '1px solid #e6e8ff', fontSize: 16 }} />
            <button type="submit" style={{ padding: '12px 18px', background: '#667eea', color: '#fff', border: 'none', borderRadius: 8, fontWeight: 700, cursor: 'pointer', fontSize: 16 }}>Send message</button>
          </form>
        </section>
      </main>

    </div>
  )
}

export default Contact
